import { css } from "styled-components";

export interface IPaddingStyleProps {
    p?: number;
    pb?: number;
    pl?: number;
    pr?: number;
    pt?: number;
    px?: number;
    py?: number;
}

export const paddingMixin = () => css<IPaddingStyleProps>`
    ${({ p }) => p !== undefined && `padding: ${p}px;`}
    ${({ pb, py }) => (pb !== undefined || py !== undefined) && `padding-bottom: ${pb || py}px;`}
	${({ pl, px }) => (pl !== undefined || px !== undefined) && `padding-left: ${pl || px}px;`}
	${({ pr, px }) => (pr !== undefined || px !== undefined) && `padding-right: ${pr || px}px;`}
	${({ pt, py }) => (pt !== undefined || py !== undefined) && `padding-top: ${pt || py}px;`}
`;
